import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import LocalData from "utils/LocalData";
import logger from "utils/logger";
import { getManager } from "utils/login";
import {setQueryStringParam} from "../utils/urls";

export default function OidcRedirectCallback(props) {
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const mgr = getManager();
        const isInIframe = window.parent !== window;

        const bundleVersion = localStorage.getItem("bundleVersion");
        const prNumber = localStorage.getItem("prNumber");

        let queryParams = isInIframe ? location.search : ""; //if iframe, is silent refresh, keep GLN params 
                                                              // else user log in, remove oidc params
        
        if (prNumber) {          
            queryParams = setQueryStringParam(queryParams, "pr", prNumber);
        } else if (bundleVersion) {
            queryParams = setQueryStringParam(queryParams, "build", bundleVersion);
        }

        if (!isInIframe) {
            mgr.signinRedirectCallback().then(() => {
                LocalData.clearToken();
                window.location.href = queryParams.length > 0 ? `/?${queryParams}` : '/';
            }).catch((err) => {
                window.location.href = queryParams.length > 0 ? `/?${queryParams}` : '/';
                logger.error("Error OIDC redirecting:", err, true);
            });
        } else {
            mgr.signinSilentCallback().then((user) => {
                logger.log("after silent", user);
            }).catch((err) => {
                logger.error("Error OIDC silent", err, true);
            });
        }

    }, []);

    return null;
}
